import { useState } from "react"

import { LoadingSpinner } from "@/components/shared"
import { GoBack } from "@/components/shared/layout"

interface BlogDetailProps {
  id: string
}

const BlogDetail = ({ id }: BlogDetailProps) => {
  const url = `${import.meta.env.VITE_WEB_BRAND_URL}/blogs/-id-${id}?webview=1`
  const [loading, setLoading] = useState(true)

  return (
    <div className="flex flex-col h-full">
      <div className="sticky top-0 z-50">
        <GoBack title="Chi tiết bài viết" className="bg-white" />
      </div>
      <div className="flex-1 relative overflow-hidden">
        {loading && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/60">
            <LoadingSpinner className="w-16 h-16" />
          </div>
        )}
        <iframe title="Blog" src={url} className="w-full h-full" onLoad={() => setLoading(false)} />
      </div>
    </div>
  )
}

export default BlogDetail
